module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-fi wrap"
  }, [_c('p', {
    staticClass: "numfiche"
  }, [_c('strong', [_vm._v(_vm._s(_vm.code))]), (_vm.ot) ? _c('span', [_vm._v(" - " + _vm._s(_vm.ot))]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "det"
  }, [_vm._v(_vm._s(_vm.detenteur.raison_sociale) + " " + _vm._s(_vm.detenteur.ville))]), _vm._v(" "), _c('p', {
    staticClass: "install"
  }, [_vm._v("\n        " + _vm._s(_vm.installation.nom) + "\n        " + _vm._s((_vm.installation.marque) ? ' - ' + _vm.installation.marque : '') + "\n        " + _vm._s((_vm.installation.modele) ? ' - ' + _vm.installation.modele : '') + "\n    ")]), _vm._v(" "), (_vm.gotFluide) ? _c('div', {
    staticClass: "btn refrigerant"
  }, [_c('i', {
    staticClass: "icon-fluid"
  }), _vm._v("\n        " + _vm._s(_vm.installation.fluide.nom) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.gotFluide) ? _c('div', [_vm._v("\n        CHARGE\n        "), _c('br'), _vm._v(" TOTALE\n        "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.installation.charge))]), _vm._v(" kg\n    ")]) : _vm._e(), _vm._v(" "), (_vm.gotFluide && _vm.isFibsdd) ? _c('div', [_vm._v("\n        TONNAGE\n        "), _c('br'), _vm._v(" ÉQUIVALENT CO"), _c('span', {
    staticClass: "smallexp"
  }, [_vm._v("2")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.installation.tonnage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53c309b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/SmallRecap.vue
// module id = 762
// module chunks = 0